module.exports = __webpack_public_path__ + "img/flag-blue.b933a7e3.svg";